import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { ObjPathProxy } from "ts-object-path";
import type {
	MyPlannResourceDictionary,
	PortfolioDeleteTranslations,
} from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	itemTitle: string;
	isPending: boolean;
	namespace: ObjPathProxy<
		MyPlannResourceDictionary,
		PortfolioDeleteTranslations
	>;
	onClose: () => void;
	onConfirm: () => void;
};

export const DeleteItemDrawer = ({
	open,
	itemTitle,
	isPending,
	namespace,
	onClose,
	onConfirm,
}: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			title={t(namespace.title)}
			closeButton
		>
			<Stack
				px={theme.spacingTokens.xl}
				pb={theme.spacingTokens.xl}
				pt={1}
				gap={3}
			>
				<Typography variant="body2">
					{t(namespace.descriptionPrefix)}
					<Typography
						component="span"
						variant="bodyMedium"
						color="text.primary"
					>
						{itemTitle}
					</Typography>
					{t(namespace.descriptionSuffix)}
				</Typography>
				<Stack gap={theme.spacingTokens.md}>
					<Button
						variant="primary"
						color="error"
						loading={isPending}
						onClick={onConfirm}
					>
						{t(namespace.confirm)}
					</Button>
					<Button variant="tertiary" disabled={isPending} onClick={onClose}>
						{t(namespace.cancel)}
					</Button>
				</Stack>
			</Stack>
		</MyPlannDrawer>
	);
};
